import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuthStore } from "../features/auth/store.ts";
import { InterviewAdminScreen } from "../features/interview-admin/InterviewAdminScreen.tsx";
import { isAdminEmail } from "../lib/admins.ts";

function InterviewAdminGuard() {
  const nav = useNavigate();
  const email = useAuthStore((s) => s.user?.email ?? s.email);
  const initialized = useAuthStore((s) => s.initialized);

  const allowed = isAdminEmail(email);

  useEffect(() => {
    if (initialized && !allowed) nav({ to: "/dashboard" });
  }, [initialized, allowed, nav]);

  if (!allowed) return null;
  return <InterviewAdminScreen />;
}

export const Route = createFileRoute("/_app/interview-admin")({
  component: InterviewAdminGuard,
});
